import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedElementType,
  updateSelectedInteraction,
  updateSelectedTakeSequence,
} from "../../app/slices/TrainingSlice";
import { ISequence } from "../../models/interactions/Sequence";

export function useUpdateActiveSequence() {
  const dispatch = useDispatch();
  const selectedElementType = useSelector(selectSelectedElementType);

  const updateSequence = useCallback(
    (sequence: ISequence) => {
      if (selectedElementType === "takeSequence") {
        dispatch(updateSelectedTakeSequence(sequence));
        return;
      }

      dispatch(updateSelectedInteraction(sequence));
    },
    [dispatch, selectedElementType]
  );

  return { updateSequence };
}
